<input matInput [matTooltip]="inputValue" [matAutocomplete]="auto" [(ngModel)]="inputValue" class="cursor-pointer"
    (ngModelChange)="filter($event)" (click)="clear()" (blur)="getLastSelected()">
<mat-autocomplete #auto="matAutocomplete" panelWidth="250px" (optionSelected)="onOptionSelected($event)">
    <mat-option *ngIf="unselectOption" [value]="null">None</mat-option>
    <mat-option *ngFor="let option of filteredOptions" [value]="option[key]">
        {{ option[key] }}
    </mat-option>
</mat-autocomplete>